<div class="page">
  <app-page-header page-title="settings.dataTypes.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <app-card-spinner [visible]="listIsLoading || detailIsLoading" type="zero"></app-card-spinner>
      <mat-card-title>{{ 'settings.dataTypes.detail' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'settings.dataTypes.editing' | translate }}</mat-card-subtitle>

      <mat-card-content>

        <!-- BEGIN - Toolbar -->
        <div class="dty-toolbar">
          <mat-form-field class="dty-search">
            <mat-label>{{ 'settings.dataTypes.search' | translate }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="search"
              (ngModelChange)="applySearch()"
              [placeholder]="'settings.dataTypes.search' | translate">
            <button
              mat-icon-button
              matSuffix
              *ngIf="search"
              (click)="search = ''; applySearch()"
              [attr.aria-label]="'common.cta.reset' | translate">
              <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
            </button>
            <mat-icon matSuffix fontSet="fal" fontIcon="fa-search" *ngIf="!search"></mat-icon>
          </mat-form-field>

          <mat-slide-toggle
            class="dty-toolbar-toggle"
            [(ngModel)]="includeDeleted"
            (change)="onIncludeDeletedChange()">
            {{ 'settings.dataTypes.showHidden' | translate }}
          </mat-slide-toggle>

          <span class="dty-toolbar-spacer"></span>

          <button mat-raised-button color="primary" (click)="onNew()">
            <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
            {{ 'settings.dataTypes.actions.add' | translate }}
          </button>
        </div>
        <!-- END - Toolbar -->

        <div class="row">

          <!-- BEGIN - List -->
          <div class="col-12 col-lg-4 dty-column">
            <div class="dty-column-title">
              {{ 'settings.dataTypes.listTitle' | translate }}
              <span class="dty-count" *ngIf="visibleDataTypes.length">{{ visibleDataTypes.length }}</span>
            </div>

            <div class="dty-empty" *ngIf="!listIsLoading && dataTypes.length === 0">
              <mat-icon fontSet="fal" fontIcon="fa-clipboard-list"></mat-icon>
              <p class="dty-empty-title">{{ 'settings.dataTypes.empty.title' | translate }}</p>
              <p class="dty-empty-text">{{ 'settings.dataTypes.empty.text' | translate }}</p>
            </div>

            <div class="dty-empty" *ngIf="!listIsLoading && dataTypes.length && !visibleDataTypes.length">
              <p class="dty-empty-text">{{ 'settings.dataTypes.empty.noMatch' | translate }}</p>
            </div>

            <div class="dty-list" *ngIf="visibleDataTypes.length">
              <div
                class="dty-row"
                *ngFor="let dataType of visibleDataTypes"
                [class.dty-row-selected]="isSelected(dataType)"
                [class.dty-row-hidden]="dataType.deleted">

                <button type="button" class="dty-row-main" (click)="onSelect(dataType)">
                  <span class="dty-badge-code">{{ dataType.dataTypeLabel }}</span>
                  <span class="dty-row-name">{{ dataType.dataTypeName }}</span>
                  <mat-icon
                    class="dty-row-hidden-icon"
                    *ngIf="dataType.deleted"
                    fontSet="fal"
                    fontIcon="fa-eye-slash"
                    [matTooltip]="'settings.dataTypes.badges.hidden' | translate"></mat-icon>
                </button>

                <button
                  mat-icon-button
                  [matMenuTriggerFor]="rowMenu"
                  [attr.aria-label]="'common.cta.actions' | translate">
                  <mat-icon fontSet="fal" fontIcon="fa-ellipsis-h"></mat-icon>
                </button>
                <mat-menu #rowMenu="matMenu">
                  <button mat-menu-item (click)="onDuplicate(dataType)">
                    <mat-icon fontSet="fal" fontIcon="fa-copy"></mat-icon>
                    {{ 'settings.dataTypes.actions.duplicate' | translate }}
                  </button>
                  <button mat-menu-item *ngIf="!dataType.deleted" (click)="onHide(dataType)">
                    <mat-icon fontSet="fal" fontIcon="fa-eye-slash"></mat-icon>
                    {{ 'settings.dataTypes.actions.hide' | translate }}
                  </button>
                  <button mat-menu-item *ngIf="dataType.deleted" (click)="onRestore(dataType)">
                    <mat-icon fontSet="fal" fontIcon="fa-trash-restore"></mat-icon>
                    {{ 'settings.dataTypes.actions.restore' | translate }}
                  </button>
                </mat-menu>
              </div>
            </div>

            <div class="dty-legend" *ngIf="includeDeleted">
              <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
              <span>{{ 'settings.dataTypes.hints.hiddenAreKept' | translate }}</span>
            </div>
          </div>
          <!-- END - List -->

          <!-- BEGIN - Editor -->
          <div class="col-12 col-lg-8 dty-column">

            <div class="dty-empty dty-empty-panel" *ngIf="!selected && !isNew">
              {{ 'settings.dataTypes.empty.selectOne' | translate }}
            </div>

            <ng-container *ngIf="selected || isNew">
              <!--
                No (ngSubmit) on purpose: mat-spinner-button renders a plain <button>,
                which defaults to type="submit" inside a form. With a submit handler
                too, one click would save twice. (btnClick) is the single entry point,
                and the reactive form directive still swallows the native submit.
              -->
              <form [formGroup]="form">

                <!-- Editor header -->
                <div class="dty-panel-title">
                  <span class="dty-badge-code">
                    {{ form.get('dataTypeLabel').value || ('settings.dataTypes.newDataType' | translate) }}
                  </span>
                  <span class="dty-panel-name">
                    {{ form.get('dataTypeName').value || ('settings.dataTypes.newDataType' | translate) }}
                  </span>
                  <span class="dty-badge dty-badge-hidden" *ngIf="selected && selected.deleted">
                    {{ 'settings.dataTypes.badges.hidden' | translate }}
                  </span>
                  <span class="dty-badge dty-badge-dirty" *ngIf="hasPendingChanges">
                    {{ 'settings.dataTypes.badges.unsaved' | translate }}
                  </span>
                  <span class="dty-toolbar-spacer"></span>
                  <mat-spinner-button
                    (btnClick)="onSubmit()"
                    role="submit"
                    [options]="saveBtnOptions"
                    class="btn-elevate">
                  </mat-spinner-button>
                </div>

                <div class="dty-hint dty-hint-warn" *ngIf="selected && selected.deleted">
                  <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                  <span>{{ 'settings.dataTypes.hints.editingHidden' | translate }}</span>
                </div>

                <!-- Identity -->
                <div class="row dty-identity">
                  <mat-form-field class="col-12 col-md-4">
                    <mat-label>{{ 'settings.dataTypes.fields.dataTypeLabel' | translate }}</mat-label>
                    <input matInput type="text" formControlName="dataTypeLabel" maxlength="50">
                    <mat-hint>{{ 'settings.dataTypes.hints.dataTypeLabel' | translate }}</mat-hint>
                    <mat-error *ngIf="form.get('dataTypeLabel').hasError('required')">
                      {{ 'common.errors.field_is_required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get('dataTypeLabel').hasError('pattern')">
                      {{ 'settings.dataTypes.errors.labelPattern' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get('dataTypeLabel').hasError('server-error')">
                      {{ form.get('dataTypeLabel').getError('server-error') }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="col-12 col-md-8">
                    <mat-label>{{ 'settings.dataTypes.fields.dataTypeName' | translate }}</mat-label>
                    <input matInput type="text" formControlName="dataTypeName">
                    <mat-hint>{{ 'settings.dataTypes.hints.dataTypeName' | translate }}</mat-hint>
                    <mat-error *ngIf="form.get('dataTypeName').hasError('required')">
                      {{ 'common.errors.field_is_required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get('dataTypeName').hasError('pattern')">
                      {{ 'settings.dataTypes.errors.namePattern' | translate }}
                    </mat-error>
                    <mat-error *ngIf="form.get('dataTypeName').hasError('server-error')">
                      {{ form.get('dataTypeName').getError('server-error') }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Fields -->
                <div class="dty-fields-header">
                  <span class="dty-column-title">
                    {{ 'settings.dataTypes.fieldsTitle' | translate }}
                    <span class="dty-count">{{ fields.length }}</span>
                  </span>
                  <span class="dty-toolbar-spacer"></span>
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    [disabled]="fields.length >= maxFields"
                    (click)="onAddField()">
                    <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                    {{ 'settings.dataTypes.actions.addField' | translate }}
                  </button>
                </div>

                <div
                  class="dty-field-list"
                  formArrayName="fields"
                  cdkDropList
                  (cdkDropListDropped)="onFieldDropped($event)">

                  <div
                    class="dty-field"
                    *ngFor="let field of fields.controls; let i = index"
                    [formGroupName]="i"
                    [id]="'dt-field-' + i"
                    cdkDrag>

                    <!-- Collapsed header -->
                    <div class="dty-field-header" [class.dty-field-invalid]="fieldIsInvalid(i)">
                      <mat-icon
                        class="dty-drag-handle"
                        cdkDragHandle
                        fontSet="fal"
                        fontIcon="fa-grip-vertical"
                        [matTooltip]="'settings.dataTypes.hints.drag' | translate"></mat-icon>

                      <span class="dty-field-position">{{ i + 1 }}</span>

                      <button type="button" class="dty-field-toggle" (click)="onToggleField(i)">
                        <span class="dty-field-name">{{ fieldSummary(i) }}</span>
                        <span class="dty-badge dty-badge-type">
                          {{ 'settings.dataTypes.types.' + field.get('type').value | translate }}
                        </span>
                        <span class="dty-badge dty-badge-required" *ngIf="field.get('required').value">
                          {{ 'settings.dataTypes.badges.required' | translate }}
                        </span>
                        <span class="dty-badge" *ngIf="field.get('readonly').value">
                          {{ 'settings.dataTypes.badges.readonly' | translate }}
                        </span>
                        <span class="dty-badge dty-badge-rule" *ngIf="field.get('requiredWhenEnabled').value">
                          {{ 'settings.dataTypes.badges.requiredWhen' | translate }}
                        </span>
                        <span class="dty-badge dty-badge-rule" *ngIf="field.get('onChangeEnabled').value">
                          {{ 'settings.dataTypes.badges.onChange' | translate }}
                        </span>
                        <mat-icon
                          class="dty-field-caret"
                          fontSet="fal"
                          [fontIcon]="fieldsExpanded[i] ? 'fa-chevron-down' : 'fa-chevron-right'"></mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        color="warn"
                        type="button"
                        (click)="onRemoveField(i)"
                        [matTooltip]="'settings.dataTypes.actions.removeField' | translate">
                        <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
                      </button>
                    </div>

                    <!-- Expanded body -->
                    <div class="dty-field-body" *ngIf="fieldsExpanded[i]">
                      <div class="row">

                        <mat-form-field class="col-12 col-md-4">
                          <mat-label>{{ 'settings.dataTypes.fields.name' | translate }}</mat-label>
                          <input matInput type="text" formControlName="name">
                          <mat-hint>{{ 'settings.dataTypes.hints.name' | translate }}</mat-hint>
                          <mat-error *ngIf="field.get('name').hasError('required')">
                            {{ 'common.errors.field_is_required' | translate }}
                          </mat-error>
                          <mat-error *ngIf="field.get('name').hasError('pattern')">
                            {{ 'settings.dataTypes.errors.namePattern' | translate }}
                          </mat-error>
                          <mat-error *ngIf="field.get('name').hasError('duplicateName')">
                            {{ 'settings.dataTypes.errors.duplicateName' | translate }}
                          </mat-error>
                          <mat-error *ngIf="field.get('name').hasError('server-error')">
                            {{ field.get('name').getError('server-error') }}
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="col-12 col-md-4">
                          <mat-label>{{ 'settings.dataTypes.fields.type' | translate }}</mat-label>
                          <mat-select formControlName="type" (selectionChange)="onTypeChange(i)">
                            <mat-option *ngFor="let type of fieldTypes" [value]="type">
                              {{ 'settings.dataTypes.types.' + type | translate }}
                            </mat-option>
                          </mat-select>
                          <mat-hint>{{ 'settings.dataTypes.typeHints.' + field.get('type').value | translate }}</mat-hint>
                          <mat-error *ngIf="field.get('type').hasError('server-error')">
                            {{ field.get('type').getError('server-error') }}
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="col-12 col-md-4">
                          <mat-label>{{ 'settings.dataTypes.fields.label' | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            formControlName="label"
                            [matAutocomplete]="labelAuto">
                          <mat-autocomplete #labelAuto="matAutocomplete">
                            <mat-option
                              *ngFor="let token of filterLabelTokens(field.get('label').value)"
                              [value]="token">
                              <span class="dty-key">{{ token }}</span>
                              <small class="dty-key-preview">{{ previewLabelToken(token) }}</small>
                            </mat-option>
                          </mat-autocomplete>
                          <mat-hint *ngIf="capabilitiesAt(i).labelUsage !== 'ignored' && field.get('label').value">
                            {{ previewLabelToken(field.get('label').value) }}
                          </mat-hint>
                          <mat-hint *ngIf="capabilitiesAt(i).labelUsage === 'ignored'">
                            {{ 'settings.dataTypes.hints.labelIgnored' | translate }}
                          </mat-hint>
                          <mat-error *ngIf="field.get('label').hasError('server-error')">
                            {{ field.get('label').getError('server-error') }}
                          </mat-error>
                        </mat-form-field>

                        <div class="col-12 dty-inline-hint" *ngIf="labelTokenIsUnknown(field.get('label').value)">
                          <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                          <span>{{ 'settings.dataTypes.hints.unknownLabelToken' | translate }}</span>
                        </div>

                        <div
                          class="col-12 dty-inline-hint dty-inline-hint-danger"
                          *ngIf="capabilitiesAt(i).labelUsage === 'required' && !field.get('label').value">
                          <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                          <span>{{ 'settings.dataTypes.hints.labelRequiredByType' | translate }}</span>
                        </div>

                        <div class="col-12 col-md-6 dty-toggles">
                          <mat-checkbox formControlName="required">
                            {{ 'settings.dataTypes.fields.required' | translate }}
                          </mat-checkbox>
                          <mat-checkbox formControlName="readonly">
                            {{ 'settings.dataTypes.fields.readonly' | translate }}
                          </mat-checkbox>
                          <mat-checkbox formControlName="multiple" *ngIf="capabilitiesAt(i).multiple">
                            {{ 'settings.dataTypes.fields.multiple' | translate }}
                          </mat-checkbox>
                        </div>

                        <!-- Type driven attributes -->
                        <mat-form-field class="col-6 col-md-3" *ngIf="capabilitiesAt(i).minLength">
                          <mat-label>{{ 'settings.dataTypes.fields.minLength' | translate }}</mat-label>
                          <input matInput type="number" min="0" formControlName="minLength">
                        </mat-form-field>

                        <mat-form-field class="col-6 col-md-3" *ngIf="capabilitiesAt(i).maxLength">
                          <mat-label>{{ 'settings.dataTypes.fields.maxLength' | translate }}</mat-label>
                          <input matInput type="number" min="0" formControlName="maxLength">
                        </mat-form-field>

                        <mat-form-field class="col-6 col-md-3" *ngIf="capabilitiesAt(i).min">
                          <mat-label>{{ 'settings.dataTypes.fields.min' | translate }}</mat-label>
                          <input matInput type="number" formControlName="min">
                        </mat-form-field>

                        <mat-form-field class="col-6 col-md-3" *ngIf="capabilitiesAt(i).max">
                          <mat-label>{{ 'settings.dataTypes.fields.max' | translate }}</mat-label>
                          <input matInput type="number" formControlName="max">
                        </mat-form-field>

                        <mat-form-field class="col-12 col-md-6" *ngIf="capabilitiesAt(i).defaultValue">
                          <mat-label>{{ 'settings.dataTypes.fields.defaultValue' | translate }}</mat-label>
                          <input matInput type="text" formControlName="defaultValue">
                          <mat-hint>{{ 'settings.dataTypes.hints.defaultValue' | translate }}</mat-hint>
                        </mat-form-field>

                        <mat-form-field class="col-12 col-md-6" *ngIf="capabilitiesAt(i).optionsSource">
                          <mat-label>{{ 'settings.dataTypes.fields.optionsSource' | translate }}</mat-label>
                          <mat-select formControlName="optionsSource">
                            <mat-option value="">{{ 'settings.dataTypes.noOptionsSource' | translate }}</mat-option>
                            <mat-option *ngFor="let source of optionsSources" [value]="source">
                              {{ 'settings.dataTypes.optionsSources.' + source | translate }}
                            </mat-option>
                          </mat-select>
                          <mat-hint>{{ 'settings.dataTypes.hints.optionsSource' | translate }}</mat-hint>
                          <mat-error *ngIf="field.get('optionsSource').hasError('server-error')">
                            {{ field.get('optionsSource').getError('server-error') }}
                          </mat-error>
                        </mat-form-field>

                        <ng-container *ngIf="capabilitiesAt(i).remoteSearch">
                          <mat-form-field class="col-12 col-md-4">
                            <mat-label>{{ 'settings.dataTypes.fields.search' | translate }}</mat-label>
                            <mat-select formControlName="search">
                              <mat-option value="">{{ 'settings.dataTypes.noSearch' | translate }}</mat-option>
                              <mat-option *ngFor="let service of searchServices" [value]="service">
                                {{ 'settings.dataTypes.searchServices.' + service | translate }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field class="col-6 col-md-4">
                            <mat-label>{{ 'settings.dataTypes.fields.bindLabel' | translate }}</mat-label>
                            <input matInput type="text" formControlName="bindLabel">
                          </mat-form-field>
                          <mat-form-field class="col-6 col-md-4">
                            <mat-label>{{ 'settings.dataTypes.fields.bindValue' | translate }}</mat-label>
                            <input matInput type="text" formControlName="bindValue">
                          </mat-form-field>
                        </ng-container>

                        <!-- Embedded closed list -->
                        <div class="col-12" *ngIf="capabilitiesAt(i).options">
                          <div class="dty-options" formArrayName="options">
                            <div class="dty-options-header">
                              <span>
                                {{ 'settings.dataTypes.optionsTitle' | translate }}
                                <span class="dty-count">{{ optionsOf(i).length }}</span>
                              </span>
                              <span class="dty-toolbar-spacer"></span>
                              <button
                                mat-stroked-button
                                type="button"
                                class="dty-mini-btn"
                                [disabled]="optionsOf(i).length >= maxOptions"
                                (click)="onAddOption(i)">
                                <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                                {{ 'settings.dataTypes.actions.addOption' | translate }}
                              </button>
                            </div>

                            <div class="dty-options-empty" *ngIf="!optionsOf(i).length">
                              {{ 'settings.dataTypes.empty.options' | translate }}
                            </div>

                            <div
                              class="row dty-option"
                              *ngFor="let option of optionsOf(i).controls; let j = index"
                              [formGroupName]="j">
                              <mat-form-field class="col-12 col-md-4">
                                <mat-label>{{ 'settings.dataTypes.fields.optionValue' | translate }}</mat-label>
                                <input matInput type="text" formControlName="value">
                                <mat-error *ngIf="option.get('value').hasError('required')">
                                  {{ 'common.errors.field_is_required' | translate }}
                                </mat-error>
                                <mat-error *ngIf="option.get('value').hasError('server-error')">
                                  {{ option.get('value').getError('server-error') }}
                                </mat-error>
                              </mat-form-field>

                              <mat-form-field class="col-12 col-md-7">
                                <mat-label>{{ 'settings.dataTypes.fields.optionLabel' | translate }}</mat-label>
                                <input
                                  matInput
                                  type="text"
                                  formControlName="label"
                                  [matAutocomplete]="optionAuto">
                                <mat-autocomplete #optionAuto="matAutocomplete">
                                  <mat-option
                                    *ngFor="let key of filterI18nKeys(option.get('label').value)"
                                    [value]="key">
                                    <span class="dty-key">{{ key }}</span>
                                    <small class="dty-key-preview">{{ previewI18nKey(key) }}</small>
                                  </mat-option>
                                </mat-autocomplete>
                                <mat-hint *ngIf="option.get('label').value">
                                  {{ previewI18nKey(option.get('label').value) }}
                                </mat-hint>
                                <mat-error *ngIf="option.get('label').hasError('server-error')">
                                  {{ option.get('label').getError('server-error') }}
                                </mat-error>
                              </mat-form-field>

                              <div class="col-12 col-md-1 dty-option-actions">
                                <button
                                  mat-icon-button
                                  color="warn"
                                  type="button"
                                  (click)="onRemoveOption(i, j)"
                                  [matTooltip]="'settings.dataTypes.actions.removeOption' | translate">
                                  <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
                                </button>
                              </div>

                              <div
                                class="col-12 dty-inline-hint"
                                *ngIf="option.get('label').value && i18nKeyIsUnknown(option.get('label').value)">
                                <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
                                <span>{{ 'settings.dataTypes.hints.unknownKey' | translate }}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Declarative rules -->
                        <div class="col-12 dty-rules">
                          <div class="dty-rules-title">{{ 'settings.dataTypes.rulesTitle' | translate }}</div>

                          <!-- requiredWhen -->
                          <ng-container *ngIf="capabilitiesAt(i).requiredWhen">
                            <mat-checkbox
                              [checked]="field.get('requiredWhenEnabled').value"
                              (change)="onToggleRule(i, 'requiredWhen', $event.checked)">
                              {{ 'settings.dataTypes.rules.requiredWhen' | translate }}
                            </mat-checkbox>

                            <div class="row dty-rule-body" *ngIf="field.get('requiredWhenEnabled').value" formGroupName="requiredWhen">
                              <mat-form-field class="col-12 col-md-4">
                                <mat-label>{{ 'settings.dataTypes.fields.ruleField' | translate }}</mat-label>
                                <mat-select formControlName="field" (selectionChange)="onRuleFieldChange(i)">
                                  <mat-option *ngFor="let name of siblingNames(i)" [value]="name">
                                    {{ name }}
                                  </mat-option>
                                </mat-select>
                                <mat-hint>{{ 'settings.dataTypes.hints.ruleField' | translate }}</mat-hint>
                              </mat-form-field>

                              <mat-form-field class="col-12 col-md-3">
                                <mat-label>{{ 'settings.dataTypes.fields.ruleOperator' | translate }}</mat-label>
                                <mat-select formControlName="operator" (selectionChange)="onOperatorChange(i)">
                                  <mat-option *ngFor="let operator of requiredWhenOperators" [value]="operator">
                                    {{ 'settings.dataTypes.operators.' + operator | translate }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>

                              <div class="col-12 col-md-5 dty-rule-values">
                                <label class="dty-rule-label">
                                  {{ 'settings.dataTypes.fields.ruleValues' | translate }}
                                </label>
                                <ng-select
                                  *ngIf="targetFieldOptions(i).length"
                                  formControlName="values"
                                  [items]="targetFieldOptions(i)"
                                  bindValue="value"
                                  bindLabel="label"
                                  [multiple]="ruleIsMulti(i)"
                                  [placeholder]="'settings.dataTypes.fields.ruleValues' | translate">
                                </ng-select>
                                <ng-select
                                  *ngIf="!targetFieldOptions(i).length"
                                  formControlName="values"
                                  [items]="noItems"
                                  [addTag]="true"
                                  [multiple]="ruleIsMulti(i)"
                                  [addTagText]="'settings.dataTypes.hints.addValue' | translate"
                                  [placeholder]="'settings.dataTypes.hints.typeValue' | translate">
                                </ng-select>
                              </div>
                            </div>
                          </ng-container>

                          <div class="dty-inline-hint" *ngIf="!capabilitiesAt(i).requiredWhen">
                            <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
                            <span>{{ 'settings.dataTypes.hints.noRequiredWhen' | translate }}</span>
                          </div>

                          <!-- onChange -->
                          <mat-checkbox
                            [checked]="field.get('onChangeEnabled').value"
                            (change)="onToggleRule(i, 'onChange', $event.checked)">
                            {{ 'settings.dataTypes.rules.onChange' | translate }}
                          </mat-checkbox>

                          <div class="row dty-rule-body" *ngIf="field.get('onChangeEnabled').value" formGroupName="onChange">
                            <mat-form-field class="col-12 col-md-5">
                              <mat-label>{{ 'settings.dataTypes.fields.handler' | translate }}</mat-label>
                              <mat-select formControlName="handler">
                                <mat-option *ngFor="let handler of onChangeHandlers" [value]="handler">
                                  {{ 'settings.dataTypes.handlers.' + handler | translate }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                            <mat-form-field class="col-12 col-md-4">
                              <mat-label>{{ 'settings.dataTypes.fields.targetField' | translate }}</mat-label>
                              <mat-select formControlName="targetField">
                                <mat-option *ngFor="let name of siblingNames(i)" [value]="name">
                                  {{ name }}
                                </mat-option>
                              </mat-select>
                              <mat-hint>{{ 'settings.dataTypes.hints.targetField' | translate }}</mat-hint>
                            </mat-form-field>

                            <div class="col-12 col-md-3 dty-toggles">
                              <mat-checkbox formControlName="applyOnInit">
                                {{ 'settings.dataTypes.fields.applyOnInit' | translate }}
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>

                      </div> <!-- /.row -->
                    </div> <!-- /.dty-field-body -->
                  </div> <!-- /.dty-field -->
                </div> <!-- /.dty-field-list -->
              </form>

              <!-- BEGIN - Live preview -->
              <div class="dty-preview">
                <div class="dty-preview-header">
                  <mat-icon fontSet="fal" fontIcon="fa-eye"></mat-icon>
                  <span class="dty-preview-title">{{ 'settings.dataTypes.previewTitle' | translate }}</span>
                  <span class="dty-toolbar-spacer"></span>
                  <button mat-stroked-button type="button" class="dty-mini-btn" (click)="onResetPreview()">
                    <mat-icon fontSet="fal" fontIcon="fa-redo"></mat-icon>
                    {{ 'settings.dataTypes.actions.resetPreview' | translate }}
                  </button>
                </div>
                <div class="dty-inline-hint">
                  <mat-icon fontSet="fal" fontIcon="fa-info-circle"></mat-icon>
                  <span>{{ 'settings.dataTypes.hints.preview' | translate }}</span>
                </div>
                <div class="dty-preview-body form-wrapper">
                  <formly-form
                    [form]="previewForm"
                    [fields]="previewFields"
                    [model]="previewModel"
                    [options]="previewOptions">
                  </formly-form>
                </div>
              </div>
              <!-- END - Live preview -->
            </ng-container>
          </div>
          <!-- END - Editor -->

        </div> <!-- /.row -->
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->
